import { Box, Button, Dialog, DialogContent } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  openStatus: boolean;
  onClose: () => void;
  onOptionClick: (option: string) => void;
  showRentalList: boolean;
  showEditTags: boolean;
  showRentalReassign: boolean;
};

export default function DoorActionsDialog({
  openStatus,
  onClose,
  onOptionClick,
  showRentalList,
  showEditTags,
  showRentalReassign,
}: Readonly<Props>) {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={openStatus} onClose={handleClose}>
      <Box>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: 300,
              width: "50vh",
              rowGap: (t) => t.spacing(2),
            }}
            alignItems="stretch"
          >
            {
              <Button
                sx={{ color: "black" }}
                onClick={() => onOptionClick("rental_list")}
              >
                {t("location_details.view_today_rentals")}
              </Button>
            }
            {showEditTags && (
              <Button
                disabled={false}
                sx={{ color: "black" }}
                onClick={() => onOptionClick("edit_tags")}
              >
                {t("location_details.edit_tags")}
              </Button>
            )}
            {showRentalReassign && (
              <Button
                sx={{ color: "black" }}
                onClick={() => onOptionClick("rental_reassign")}
              >
                {t("location_details.rental_reassign.button_text")}
              </Button>
            )}
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
}
